import React, { useEffect } from 'react';
import { X, Info, Warning, CheckCircle } from '@phosphor-icons/react';

const Toast = ({ 
  message, 
  type = 'info', 
  isVisible, 
  onClose, 
  duration = 4000 
}) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  const getToastStyles = () => {
    const baseStyles = {
      position: 'fixed',
      top: '20px',
      right: '20px',
      zIndex: 1000,
      padding: '16px 20px',
      borderRadius: '12px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      maxWidth: '400px',
      minWidth: '300px',
      animation: 'slideIn 0.3s ease-out',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '14px',
      lineHeight: '1.4'
    };

    const typeStyles = {
      info: {
        background: '#E3F2FD',
        color: '#1565C0',
        border: '1px solid #BBDEFB'
      },
      warning: {
        background: '#FFF3E0',
        color: '#E65100',
        border: '1px solid #FFCC02'
      },
      success: {
        background: '#E8F5E8',
        color: '#2E7D32',
        border: '1px solid #C8E6C9'
      },
      error: {
        background: '#FFEBEE',
        color: '#C62828',
        border: '1px solid #FFCDD2'
      }
    };

    return { ...baseStyles, ...typeStyles[type] };
  };

  const getIcon = () => {
    const iconProps = { size: 20, weight: 'bold' };
    
    switch (type) {
      case 'success':
        return <CheckCircle {...iconProps} />;
      case 'warning':
        return <Warning {...iconProps} />;
      case 'error':
        return <Warning {...iconProps} />;
      default:
        return <Info {...iconProps} />;
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          
          @keyframes slideOut {
            from {
              transform: translateX(0);
              opacity: 1;
            }
            to {
              transform: translateX(100%);
              opacity: 0;
            }
          }
        `}
      </style>
      <div style={getToastStyles()}>
        {getIcon()}
        <div style={{ flex: 1 }}>
          {message}
        </div>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0.7,
            transition: 'opacity 0.2s'
          }}
          onMouseOver={e => e.currentTarget.style.opacity = 1}
          onMouseOut={e => e.currentTarget.style.opacity = 0.7}
        >
          <X size={16} />
        </button>
      </div>
    </>
  );
};

export default Toast; 